<!-- If there are no errors line items, make the message bold. Zach thinks it looks better this way -->
<span>{{ message }}</span>

<div class="error-list-container">
  @if (errors.length > 0) {
    <ul>
      @for (error of errors; track error) {
        <li>
          {{ error }}
        </li>
      }
    </ul>
  }
</div>

@if (notes.length > 0) {
  <div>
    <span class="section-header">NOTE:</span>
    <ul>
      @for (note of notes; track note) {
        <li>
          {{ note }}
        </li>
      }
    </ul>
  </div>
}

<div class="action-container">
  <button mat-button (click)="ok()">OK</button>
</div>